import { locationMenuService } from "src/services";
import { getUser, isGuestUser, setUser } from "../helperMethods";
import { logout } from "src/Features/AccountSetup/redux/actions";
import { IRefreshTokenPayload } from "src/models/forms.model";
import { ADD_PAYMENT_USER, CUSTOMER_MICRO_SERVICE, ORDER_MICRO_SERIVCE, utcTimeLambdaURL } from "src/constants";
import axiosNoInterceptor from "src/services/axiosNoInterceptor";
import { updateUserData } from "src/Features/AccountSetup/redux/slices";

function calculateCurrentUtcTime() {
    // Padding single digits with leading zero. Because our lambda function return date in specific format e.g: 2025-07-18 12:04:35
    const paddingWithZero = (number) => String(number).padStart(2, '0');
    let currentUTCDate = new Date();

    // here formatted the date in this format : Year-Month-Date Hours:Minutes:Seconds 
    let currentUTC_time =
        `${currentUTCDate.getUTCFullYear()}-${paddingWithZero(currentUTCDate.getUTCMonth() + 1)}-${paddingWithZero(currentUTCDate.getUTCDate())} ` +
        `${paddingWithZero(currentUTCDate.getUTCHours())}:${paddingWithZero(currentUTCDate.getUTCMinutes())}:${paddingWithZero(currentUTCDate.getUTCSeconds())}`;

    return { data: { time: currentUTC_time } }
}

export const currentUtcTime = async () => {
    let response;
    try {
        response = await axiosNoInterceptor.get(utcTimeLambdaURL)
        return response?.data?.time;
    } catch (error) {
        response = calculateCurrentUtcTime();
        return response.data.time;
    }
}

const refreshAuthToken = async (data: IRefreshTokenPayload) => {
    const response = await axiosNoInterceptor.post(`${CUSTOMER_MICRO_SERVICE}/auth/refresh-token`, data, {
        headers: {
            'Authorization': "token",
            'token': "token"
        }
    })
    return response.data.data;
};

export const isTokenExpired = async (user) => {
    if (isGuestUser(user) || !user?.authentication_token) {
        return { shouldRefetchToken: false, shouldLogout: false };
    }
    const authExpiresAt = user.expires_at || null;
    const refreshExpiresAt = user.refresh_expires_at || null;
    const utcNow = await currentUtcTime();
    const currentDate = new Date(utcNow).getTime();
    const authTokenExpiry = new Date(authExpiresAt).getTime();
    const refreshTokenExpiry = new Date(refreshExpiresAt).getTime();
    const shouldLogout = authTokenExpiry <= currentDate && refreshTokenExpiry <= currentDate;
    const shouldRefetchToken = authTokenExpiry <= currentDate || refreshTokenExpiry <= currentDate || !authExpiresAt;
    return { shouldRefetchToken, shouldLogout };
}

export const refreshToken = async (dispatch: any, user) => {
    let response = null;
    try {
        response = await refreshAuthToken({
            refresh_token: user.refresh_token,
            auth_token: user.authentication_token,
        });
        setUser(response);
        dispatch(updateUserData(response));
    }
    catch (error) {
        logout(dispatch);
    }
    return response;
}

export const isPaymentTokenExpired = async (user) => {
    const authExpiresAt = user.expires_at || null;
    const utcNow = await currentUtcTime();
    const currentDate = new Date(utcNow).getTime();
    const authTokenExpiry = new Date(authExpiresAt).getTime();
    const shouldRefetchToken = authTokenExpiry <= currentDate || !user?.authentication_token;
    return shouldRefetchToken;
}

export const refetchPaymentToken = async (paymentId, isAddPayment = false) => {
    let verifyPaymentLinkData = null;
    try {
        if (isAddPayment) {
            verifyPaymentLinkData = await verifyAddPaymentId(paymentId);
        }
        else {
            verifyPaymentLinkData = await verifyRequestPaymentId(paymentId);
        }
        sessionStorage.setItem(
            ADD_PAYMENT_USER,
            JSON.stringify(verifyPaymentLinkData),
        );
    }
    catch (error) {
        console.log(error?.response);
    }
    return verifyPaymentLinkData;
}

const verifyRequestPaymentId = async (paymentId) => {
    const response = await axiosNoInterceptor.get(`${ORDER_MICRO_SERIVCE}/request-payment/${paymentId}?is_catering=1`, {
        headers: {
            'Authorization': "token",
            'token': "token"
        }
    })
    return response.data.data;
}

const verifyAddPaymentId = async (paymentId) => {
    const response = await axiosNoInterceptor.get(`${ORDER_MICRO_SERIVCE}/verify-payment-link/${paymentId}?is_catering=1`, {
        headers: {
            'Authorization': "token",
            'token': "token"
        }
    })
    return response.data.data;
}